import ApiService from "@/utils/request"

export const classmateServe = {
  search(params) {
    return ApiService.query(`alumni/search/alumni/`, params)
  },
  getMyUniversity(id) {
    return ApiService.query(`alumni/university/${id}/`)
  },
  getMySchool(id) {
    return ApiService.query(`alumni/education/${id}/`)
  },
  getClassmatesInfo(id, params) {
    return ApiService.query(`alumni/mate/info/${id}/`, params)
  },
  //加入某地同学录人数
  getEnteredSchoolCount(params) {
    return ApiService.query(`alumni/education/count/`, params)
  },
  //加入某地校友录人数
  getEnteredUniversityCount(params) {
    return ApiService.query(`alumni/university/count/`, params)
  }
}
